export default function Habilidades() {
  const habilidadesGrupo1 = [
    'Fazer prompts perfeitos pra extrair o máximo possível da IA',
    'Fazer imagens com IA',
    'Fazer músicas com IA',
    'Fazer vídeos com IA',
    'Fazer sites completos prontos pra vender',
    'Acelerar de forma absurda sua aprendizagem de qualquer tema com IA',
    'Estudar com IA',
    'Comprar e vender Bitcoin',
    'Entender a importância do Bitcoin pro futuro',
    'Alterar sua preferência temporal e juntar muito dinheiro',
    'Descobrir várias formas de ganhar dinheiro, mesmo sendo criança, através da nova economia',
    'Aprender a habilidade mais importante de todas e que ninguém domina: Vendas',
    'Usar sua imaginação pra criar negócios lucrativos muito antes dos 20 anos de idade',
    'Desbloquear sua verdadeira vontade'
  ];

  const habilidadesGrupo2 = [
    'Lutar pela sua liberdade',
    'Destravar sua oratória, perdendo o medo de falar em público',
    'Desenvolver uma linguagem persuasiva',
    'Dominar suas emoções',
    'Criar seu plano de vida e caminhar rumo ao seu propósito pessoal',
    'Despertar para o autodidatismo e desenvolver sua capacidade de aprender sozinho o que for de seu interesse',
    'Aprender a gostar de coisas difíceis',
    'Aprender a comer melhor',
    'Aprender a dominar a mente',
    'Aprender a fortalecer o espírito',
    'Ser mais criativo',
    'Sonhar e usar todo o seu poder de imaginação',
    'Jogar xadrez e pensar de forma estratégica',
    'Montar o cubo mágico e adquirir coordenação motora, velocidade de raciocínio',
    'Aumentar sua capacidade de memorização'
  ];

  return (
    <section className="relative py-16 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-20 space-y-4 md:space-y-6">
            <div className="inline-flex items-center gap-2 px-3 md:px-4 py-2 rounded-full bg-neon-purple/10 border border-neon-purple/30 backdrop-blur-sm">
              <i className="ri-star-fill text-neon-purple text-sm md:text-base"></i>
              <span className="text-neon-purple text-xs md:text-sm font-semibold tracking-wide">HABILIDADES DO FUTURO</span>
            </div>

            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight max-w-5xl mx-auto px-4">
              Aqui Ele Vai Aprender Coisas Que a
              <span className="block bg-gradient-to-r from-neon-blue via-neon-purple to-neon-pink bg-clip-text text-transparent mt-2">Maioria dos Adultos Nem Sonham em Saber</span>
            </h2>

            <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
              Todas as habilidades e ações que seu filho será capaz de realizar sozinho após o curso completo
            </p>
          </div>

          {/* Habilidades em 2 Colunas */}
          <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-12 md:mb-16">
            {/* Grupo 1 */}
            <div className="bg-dark-800/50 backdrop-blur-sm border border-neon-blue/20 rounded-2xl md:rounded-3xl p-6 md:p-8 hover:border-neon-purple/50 transition-all duration-500 hover:shadow-[0_0_40px_rgba(168,85,247,0.3)]">
              <div className="space-y-2">
                {habilidadesGrupo1.map((item, index) => (
                  <div 
                    key={index}
                    className="flex items-start gap-2 md:gap-3 group/item"
                  >
                    <div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 mt-0.5 flex items-center justify-center">
                      <i className="ri-checkbox-circle-fill text-base md:text-xl text-neon-blue group-hover/item:scale-125 transition-transform duration-300"></i>
                    </div>
                    <p className="text-sm md:text-base text-gray-300 leading-snug group-hover/item:text-white transition-colors duration-300">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Grupo 2 */}
            <div className="bg-dark-800/50 backdrop-blur-sm border border-neon-purple/20 rounded-2xl md:rounded-3xl p-6 md:p-8 hover:border-neon-blue/50 transition-all duration-500 hover:shadow-[0_0_40px_rgba(0,212,255,0.3)]">
              <div className="space-y-2">
                {habilidadesGrupo2.map((item, index) => (
                  <div 
                    key={index}
                    className="flex items-start gap-2 md:gap-3 group/item"
                  >
                    <div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 mt-0.5 flex items-center justify-center">
                      <i className="ri-checkbox-circle-fill text-base md:text-xl text-neon-purple group-hover/item:scale-125 transition-transform duration-300"></i>
                    </div>
                    <p className="text-sm md:text-base text-gray-300 leading-snug group-hover/item:text-white transition-colors duration-300">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Final Message */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-neon-blue/20 via-neon-purple/20 to-neon-pink/20 blur-3xl"></div>
            <div className="relative bg-dark-800/60 backdrop-blur-xl border border-neon-blue/30 rounded-2xl p-8 text-center">
              <i className="ri-sparkling-2-fill text-5xl text-neon-blue mb-4"></i>
              <p className="text-xl text-white leading-relaxed">
                Seu filho vai aprender que tudo é possível, e que ele é capaz de fazer qualquer coisa nesse mundo, inclusive mudar o mundo
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
